import { useMutation, useQueryClient } from "@tanstack/react-query";
import { bankingAccountsKeys } from "Api/Queries/Accounts/useBankingAccounts";
import { VERIFICATIONS_QUERY_KEY } from "Api/Queries/Verifications/useVerificationsQuery";
import { postBankingAccountsSync } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

export const useBankingAccountsSync = () => {
  const queryClient = useQueryClient();

  // Deliberately no onError toast: this sync fires automatically on dashboard
  // mount (useSyncAccountsWhenRegionReady), not from a user action, and its
  // failures were a main source of error-toast spam on app open. Server-side
  // failures (5xx) still become Sentry events via the global MutationCache
  // handler; 4xx only leave a breadcrumb.
  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(() =>
      postBankingAccountsSync(),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: bankingAccountsKeys.all });
      queryClient.invalidateQueries({
        queryKey: [VERIFICATIONS_QUERY_KEY],
      });
    },
  });
};
